import { reflect } from '@effector/reflect';
import { Button, ButtonProps, Popover } from '@mantine/core';
import { ChevronDown } from 'lucide-react';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ExportReportModel, translated } from 'shared/lib';
import cls from './export-report.module.scss';

export type ExportReportProps = ButtonProps;

export const createExportReport = (model: ExportReportModel) => {
	const ExcelButton = reflect({
		view: Button,
		bind: {
			onClick: model.exportExcelClicked,
			variant: 'ghost' as const,
			'data-test-id': 'export-excel',
			children: translated('export-report.export-excel'),
			classNames: { inner: cls.exportReportButtonInner },
		},
	});

	const PdfButton = reflect({
		view: Button,
		bind: {
			onClick: model.exportPdfClicked,
			variant: 'ghost' as const,
			'data-test-id': 'export-pdf',
			children: translated('export-report.export-pdf'),
			classNames: { inner: cls.exportReportButtonInner },
		},
	});

	const ExportReport = forwardRef<HTMLButtonElement, ExportReportProps>((props, ref) => {
		const { t } = useTranslation();

		return (
			<Popover
				position='bottom-start'
				offset={0}
			>
				<Popover.Target>
					<Button
						ref={ref}
						fullWidth
						variant='primary'
						data-test-id='export-report'
						rightSection={<ChevronDown />}
						{...props}
					>
						{t('export-report.export')}
					</Button>
				</Popover.Target>
				<Popover.Dropdown className={cls.exportReportDropdown}>
					<ExcelButton />
					<PdfButton />
				</Popover.Dropdown>
			</Popover>
		);
	});

	return ExportReport;
};
